module.exports = __webpack_public_path__ + "img/banner.3.e68c2743.png";